<div class="ion-no-padding">
<form novalidate [formGroup]="form" (keyup.enter)="onFormSubmit()" (ngSubmit)="onFormSubmit()" class="phone-modal__form form">
    
  <h1 class="phone-modal__form-title">{{ 'SET_NEW_PASSWORD.HEADING' | translate }}</h1>
  <p class="phone-modal__form-desc">{{ 'SET_NEW_PASSWORD.INSTRUCTIONS' | translate }}</p>

  <section formGroupName="matchingPasswords">

    <ion-item>

      <ion-label position="fixed">{{ 'SET_NEW_PASSWORD.PASSWORD' | translate }}</ion-label>
      <ion-input formControlName="password" (focus)="passwordFocus=true;" (blur)="passwordFirstBlur=true; passwordFocus=true" tabindex="11" type="password"  [ngClass]="{
          'is-invalid': password.invalid && password.errors?.required && tryToSubmit
        }"></ion-input>
    </ion-item>
    
    <div class="invalid-feedback" *ngIf="password.invalid && password.errors?.required && tryToSubmit">
      {{ 'SET_NEW_PASSWORD.ERR_PASSWORD_REQUIRED' | translate }}
    </div>
    <div class="invalid-feedback" *ngIf="password.invalid && !!password.errors?.minlength">
      {{ 'SET_NEW_PASSWORD.ERR_PASSWORD_LENGTH' | translate }}
    </div>

    <ion-item>
      <ion-label position="fixed">{{ 'SET_NEW_PASSWORD.REPEAT_PASSWORD' | translate }}</ion-label>
      <ion-input formControlName="confirmPassword" (focus)="confirmPasswordFocus=true;" (blur)="confirmPasswordFirstBlur=true; confirmPasswordFocus=false" tabindex="11" type="password"  [ngClass]="{
        'is-invalid': ( confirmPassword.invalid || matchingPasswords.invalid ) && ( confirmPasswordFirstBlur || tryToSubmit )
      }"></ion-input>
    </ion-item>

     <div class="invalid-feedback" *ngIf="confirmPassword.invalid && confirmPassword.errors?.required && tryToSubmit">
      {{ 'SET_NEW_PASSWORD.ERR_REPEAT_PASSWORD_REQUIRED' | translate }}
    </div>
    <div class="invalid-feedback" *ngIf="matchingPasswords.invalid && !password.invalid && !confirmPassword.invalid && ( passwordFirstBlur || tryToSubmit )">
      {{ 'SET_NEW_PASSWORD.ERR_REPEAT_PASSWORD_NOT_THE_SAME' | translate }}
    </div>

  </section>

  <ion-button *ngIf="!loading" [disabled]="form.invalid" class="ion-no-padding" type="submit" class="btn--large" expand="full">{{ 'SET_NEW_PASSWORD.BTN_CONFIRM' | translate }}</ion-button>
  <ion-button *ngIf="loading"  disabled="true" class="ion-no-padding"  class="btn--large" expand="full"><ion-spinner name="crescent"></ion-spinner></ion-button>

</form>
</div>